
export class Motif {
    userId: string;
    _id:string;
    created:Date;
    updated: Date;
    initrec:string;
    creerec:string;
    encoursrec:string;
    initprearb:string;
    repprearb:string;
    initarb:string;
    initcomite:string;
    repacquireur:string;
    relancerec:string;
    initrech:string;
    currentdate:number;
  groupe:[]
  }
